import {Component, OnInit, ViewEncapsulation, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExpressionBuilderModel } from 'src/app/shared/workflow-components/expression-builder/expression-builder.model';
import { CODE_WORKFLOW_COMPONENT, Model_WorkflowComponent, Model_VariableEnvironnement, Model_Datasource, TYPE_COMPONENT_CONDITIONS } from 'src/app/app.models';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-workflow-rules-builder',
    templateUrl: './workflow-rules-builder.component.html',
    styleUrls: ['./workflow-rules-builder.component.scss'],
})
export class WorkflowRulesBuilderComponent implements OnInit {
    model: ExpressionBuilderModel;
    expressionBuilderControl = new FormControl();
    typeConditions?: TYPE_COMPONENT_CONDITIONS;
    TYPE_COMPONENT_CONDITIONS = TYPE_COMPONENT_CONDITIONS;

    constructor(
        public dialogRef: MatDialogRef<WorkflowRulesBuilderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { 
            components: Model_WorkflowComponent[], 
            variables: Model_VariableEnvironnement[], 
            datasources: Model_Datasource[], 
            typeConditions: TYPE_COMPONENT_CONDITIONS, 
            conditions: any 
        },
    ) {
        this.typeConditions = data.typeConditions;
        if (data.conditions !== null && data.conditions !== undefined) {
            this.expressionBuilderControl.patchValue(data.conditions);
        }
        this.model = ExpressionBuilderModel.initModel({
            ID: 'expression-builder',
            CODE: CODE_WORKFLOW_COMPONENT.EXPRESSION_BUILDER,
            LABEL: 'Expression Builder'
        }, {
            datasource: data.components.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]` })),
            COMPONENTS: data.components,
            VARIABLES_ENVIRONNEMENT: data.variables,
            DATASOURCES: data.datasources
        });
    }

    ngOnInit() {
    }
 
    dismiss() {
        return this.dialogRef.close();
    }

    onSubmit() {
        this.dialogRef.close(this.expressionBuilderControl.value);
    }
}